import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { getDollarFormattedText } from '../../../utils/strings';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.costs.avgnetprice-section.title',
    defaultMessage: `So what's it going to cost?`,
  },
  subTitle: {
    id: 'hubs.costs.avgnetprice-section.subtitle',
    defaultMessage:
      'The <strong>average annual net price</strong> for federal financial aid recipients after aid from the school, state, or federal government. For public schools, this is only the average cost for in-state students.',
  },
  byFamIncome: {
    id: 'hubs.costs.avgnetprice-section.by-family-income',
    defaultMessage: `By Family Income`,
  },
  byFamIncomeContent: {
    id: 'hubs.costs.avgnetprice-section.by-family-income-content',
    defaultMessage: `Depending on the federal, state, or institutional grant aid available, students in your income bracket may pay more or less than the overall average costs.`,
  },
  famIncome: {
    id: 'hubs.costs.avgnetprice-section.family-income',
    defaultMessage: `Family Income`,
  },
  avgNetCost: {
    id: 'hubs.costs.avgnetprice-section.avg-net-cost',
    defaultMessage: `Average Net Cost`,
  },
});

class AvgNetCostSection extends React.PureComponent {
  static propTypes = {
    averageNetPrices: PropTypes.object,
  };

  getAvgNetPriceValue = (key) => {
    const { averageNetPrices } = this.props;
    let value = '';
    if (key) {
      value = getDollarFormattedText(get(averageNetPrices, key, ''));
      value = value ? `$${value}` : '';
    }

    return value;
  };

  render() {
    const { averageNetPrices } = this.props;

    return !isEmpty(averageNetPrices) ? (
      <div className="common-full-width">
        <div
          name="cost-module"
          data-cy="avg-net-cost-section-container"
          className="common-core-width avg-net-cost-section-container"
        >
          <h3 className="heading">
            <FormattedMessage {...messages.title} />
          </h3>
          <div className="avg-net-cost-content">
            <div className="information-content">
              <div className="subtitle">
                <FormattedMessage
                  {...messages.subTitle}
                  values={{ strong: (...chunks) => <strong>{chunks}</strong> }}
                />
              </div>
              <h3 className="fam-income-title">
                <FormattedMessage {...messages.byFamIncome} />
              </h3>
              <div className="fam-income-content">
                <FormattedMessage {...messages.byFamIncomeContent} />
              </div>
            </div>
            <div className="cost-content">
              <h3>
                <FormattedMessage {...messages.famIncome} />
              </h3>
              <h3>
                <FormattedMessage {...messages.avgNetCost} />
              </h3>
              <div>$0 - $30,000</div>
              <div>{this.getAvgNetPriceValue('0-30.value')}</div>
              <div>$30,001 - $48,000</div>
              <div>{this.getAvgNetPriceValue('30-48.value')}</div>
              <div>$48,001 - $75,000</div>
              <div>{this.getAvgNetPriceValue('48-75.value')}</div>
              <div>$75,001 - $110,000</div>
              <div>{this.getAvgNetPriceValue('75-110.value')}</div>
              <div>$110,001+</div>
              <div>{this.getAvgNetPriceValue('110+.value')}</div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default injectIntl(AvgNetCostSection);
